import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import AttendanceAnalytics from './AttendanceAnalytics';

export default function MyAttendance() {
    const { user } = useAuth();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!user?.id) return;

        fetch(`/api/my-profile?userId=${user.id}`)
            .then(res => res.json())
            .then(data => {
                setData(data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, [user]);

    if (loading) return <div className="p-8">Loading your academic profile...</div>;
    if (!data) return <div className="p-8 text-red-500">Academic record not found.</div>;

    const { student, overall, monthly, subjects } = data;

    return (
        <div className="space-y-6">
            <h1 className="text-2xl font-bold font-heading text-primary">My Attendance</h1>
            <AttendanceAnalytics
                student={student}
                overall={overall}
                monthly={monthly}
                subjects={subjects}
            />
        </div>
    );
}
